import { useEffect } from 'react'

/**
 * componentDidMount for React.FC
 */
export const useDidMount = (func: Function) =>
  useEffect(() => {
    func()
  }, [])
